import { DeepPartial, useForm } from 'react-hook-form';
import { createFromValidationResolver } from '@cp/utils/form';
import { useCurrentLanguage } from '@cp/shared/localization';
import { useEffect } from 'react';
import { useTrackEvent } from 'src/shared/tracking';
import { VacancyEvents } from '../lib';
import { FormModel } from './form';

const resolver = createFromValidationResolver(FormModel);

export const useVacancyForm = (defaultValues: DeepPartial<FormModel> = {}) => {
  const languageCode = useCurrentLanguage();
  const track = useTrackEvent();
  const form = useForm<FormModel>({
    defaultValues,
    resolver,
    context: { languageCode },
  });
  useEffect(
    () =>
      form.subscribe({
        formState: { values: true },
        callback: ({ name }) => {
          switch (name) {
            case 'date':
              track(VacancyEvents.VacancyDateSelect());
              break;
            case 'startedAt':
              track(VacancyEvents.VacancyTimeStartSelect());
              break;
            case 'endedAt':
              track(VacancyEvents.VacancyTimeEndSelect());
              break;
            case 'address.address':
              track(VacancyEvents.VacancyAddressSelect());
              break;
            case 'children.0.age':
              track(VacancyEvents.VacancyAgeSelect());
              break;
            case 'childWithDisabilities':
              track(VacancyEvents.VacancyChildWithDisabilities());
              break;
            case 'regularSpecialist':
              track(VacancyEvents.VacancyRegularSpecialist());
              break;
            default:
          }
        },
      }),
    [form, track],
  );
  return form;
};
